// Static defaults — primarily for components that need module-level constants.
// For dynamic, admin-configurable branding, use `useBrand()` from BrandContext instead.

// Fallback: use Lucide Hexagon icon text-based logo when no image is available
export const LOGO_FULL = "";
export const LOGO_MARK = "";
export const WALLPAPER = "";
export const TAGLINE = "Play beyond limits";

export { useBrand, BrandProvider, resolveAssetUrl } from "./BrandContext";
